// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';
const lightbox = GLightbox();
